import React from 'react'

import Icon from '../data/icon.png';
const Entete = () => {
    return (
        <div className="flex justify-between gap-3">
            <div className="flex flex-col gap-3">
                <h1 className='font-bold'>École privée Grenoble</h1>
                <h2 className='text-sm font-bold'>Travail-Discipline-Réussite</h2>
                <h2>Tel: 32-34-81-61/26-37-39-05</h2>
            </div>
            <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
            <div className="flex flex-col text-right gap-3">
                <h1 className='font-bold'> مدرســة كـرينــوبــل الخاصة </h1>
                <h1 className='font-bold'> عمل - انـضبـاط - نجـاح  </h1>
                <h2> 32-34-81-61/26-37-39-05 : الهاتف</h2>
            </div>
        </div>
    )
}

export default Entete